
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 27.333c7.364 0 13.333-5.97 13.333-13.333C27.333 6.636 21.363.667 14 .667 6.636.667.667 6.637.667 14c0 7.364 5.97 13.333 13.333 13.333zm-.211-7.14L21.527 9.25c.261-.337.324-.797.162-1.197-.161-.4-.52-.674-.935-.715a1.115 1.115 0 00-1.047.519l-7.04 9.954-4.607-3.84a1.1 1.1 0 00-1.59.183c-.39.508-.311 1.25.177 1.656l5.525 4.603a1.11 1.11 0 001.617-.221z"}})])
          )
        }
      }
    